import { logEvent } from "@/service/logs/log";
import { createPath } from "@/service/routing/routing";
import { useContext } from "react";
import { ResourceContext } from "@/contexts/resource-context";
import { TutorialCard } from "@/components/tutorial/tutorial-card";

export const Icd10TutorialCard = ({
  tutorial,
  code,
}: {
  tutorial: TutorialPreviewVM;
  code: string;
}) => {
  const { logView } = useContext(ResourceContext);

  return (
    <TutorialCard
      tutorial={tutorial}
      onClick={() => {
        logEvent("icd10_internal_link_click", logView, {
          icd_code: code,
          resource_path: createPath("tutorial.show", {
            category: tutorial.category.slug,
            tutorial: tutorial.slug,
          }),
          resource_type: "tutorial",
        });
      }}
      onClickCategory={() => {
        logEvent("icd10_internal_link_click", logView, {
          icd_code: code,
          resource_path: createPath("tutorial.category", {
            slug: tutorial.category.slug,
          }),
          resource_type: "tutorial_category",
        });
      }}
    />
  );
};
